import * as React from "react";
import * as Glob from "../../Globale";
import * as Dati from "../../Dati";
import * as Data from "../../Data";
import { Pie } from "react-chartjs-2";
import { ChiamaAPI, Trad, BaseComponent } from "../";
import { DateRange } from "../../components/custom/DateRange/DateRange";
import { PortletToogleIcon } from "../common/PortletToogleIcon";
import * as Dashboard from "./Dashboard";
import { IInitialDates, GetInitialDates } from "./DashboardHelpers";
import { DateRangeData, DateRanges, GetDateRange } from "../../helpers/DateHelper";

interface IDashboardProdottiEmessiState {
    Aggiorna: number;
    DateFrom: Data.CData;
    DateTo: Data.CData;
}

export class DashboardProdottiEmessi extends BaseComponent<{}, IDashboardProdottiEmessiState> {
    private _Dati: Dati.ChartData = new Dati.ChartData();
    private _InitialDates: IInitialDates = GetInitialDates();
    private _InitialDatesRange: DateRangeData = GetDateRange(DateRanges.CurrentMonth);

    public constructor(props: any) {
        super(props);
        this.state = { Aggiorna: 1, DateFrom: new Data.CData(this._InitialDatesRange.DateFrom), DateTo: new Data.CData(this._InitialDatesRange.DateTo) };

        this.OnChange = this.OnChange.bind(this);
        this.OnRangeChange = this.OnRangeChange.bind(this);
    }

    private OnRisProdottiEmessi(sender: ChiamaAPI, dati: Dati.CRisAPIDato<Dati.ChartData>, datiNuovi: boolean): React.ReactNode {
        this._Dati = dati.Dato;

        //Traduzione etichette
        for (let x: number = 0; x < this._Dati.labels.length; x++) {
            this._Dati.labels[x] = Trad.Trad(this._Dati.labels[x]);
        }

        //Imposto i dati dei colori
        for (let x: number = 0; x < this._Dati.datasets.length; x++) {
            this._Dati.datasets[x].backgroundColor = [];
            this._Dati.datasets[x].borderColor = [];
            for (let i: number = 0; i < this._Dati.datasets[x].data.length; i++) {
                this._Dati.datasets[x].backgroundColor.push(Glob.ColoreStaticA(i));
                this._Dati.datasets[x].borderColor.push(Glob.ColoreStaticA(i));
                this._Dati.datasets[x].borderWidth = 1;
            }
        }
        return this._Dati.labels.length ? (
            <div className="chart-wrapper">
                <Pie data={this._Dati} options={{ maintainAspectRatio: false }} />
            </div>
        ) : (
            <div className="kt-widget4">
                <div className="kt-widget4__item">
                    <p className="kt-font-info">{Trad.Trad("Nessun dato presente")}</p>
                </div>
            </div>
        );
    }

    public OnRangeChange(value: DateRangeData) {
        this.setState({
            DateFrom: value ? new Data.CData(value.DateFrom) : this._InitialDates.DateFrom,
            DateTo: value ? new Data.CData(value.DateTo) : this._InitialDates.DateTo
        });
    }

    componentDidMount() {
        setInterval(() => {
            this.setState({ Aggiorna: this.state.Aggiorna + 1 });
        }, Dashboard.SecondsAutomaticUpdate * 1000);
    }

    public render() {
        return (
            <div className="kt-portlet portlet-shadow kt-portlet--sortable" data-ktportlet="true">
                <div className="kt-portlet__head ui-sortable-handle">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-label">{Trad.Trad("ProdottiEmessi")}</h3>
                    </div>
                    <div className="kt-portlet__head-toolbar">
                        <PortletToogleIcon />
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <DateRange DateFrom={this.state.DateFrom.DataBreve} DateTo={this.state.DateTo.DataBreve} OnChange={this.OnChange} OnRangeChange={this.OnRangeChange} />
                    <ChiamaAPI
                        Aggiornare={this.state.Aggiorna}
                        URL={"/api/Polizza/ProdottiEmessi?dataInizio=" + this.state.DateFrom.DataBreve + "&dataFine=" + this.state.DateTo.DataBreve}
                        OnRis={(s, d, dn) => this.OnRisProdottiEmessi(s, d, dn)}
                        OnErrore={this.OnErrore}
                        ImmaginePrecaricamento={true}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Dashboards/DashboardProdottiEmessi.tsx